module.exports = __webpack_public_path__ + "static/Karo_1_min-36f68b5782cde2b075d1f395c969afc6.jpg";